import React from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import ProfileForm from "../../../../components/contact/form/ProfileForm";
import { authStorage } from "../../../../services/apiClient";

const Profile = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authStorage.clearToken();
    navigate("/login");
  };

  return (
    <div className="main-page-wrapper p0">
      <Helmet>
        <title>Profil || Aplikasi Gotong Royong</title>
      </Helmet>

      <div className="user-data-page clearfix d-lg-flex">
        <div className="illustration-wrapper d-flex align-items-center justify-content-between flex-column">
          <h3 className="font-rubik">
            Lengkapi profil Anda <br /> untuk berbagi manfaat.
          </h3>
          <div className="illustration-holder">
            <img
              src="images/assets/ils_08.svg"
              alt="illustration"
              className="illustration"
            />
          </div>
        </div>

        <div className="form-wrapper">
          <div className="d-flex justify-content-between">
            <div className="logo">
              <Link to="/">
                <img src="images/logo/gotong-royong-50.png" alt="logo" />
              </Link>
            </div>
            <Link className="font-rubik go-back-button" to="/">
              Kembali ke Beranda
            </Link>
          </div>
          <div className="mt-30">
            <h2>Profil Relawan</h2>
            <p className="header-info pt-30 pb-50">
              Perbarui informasi domisili dan keahlian untuk gotong royong.
            </p>
            <button
              type="button"
              className="theme-btn-one"
              onClick={handleLogout}
            >
              Keluar
            </button>
          </div>

          <ProfileForm />
        </div>
      </div>
    </div>
  );
};

export default Profile;
